export default __webpack_public_path__ + "static/media/img--interiors-9.dba3e72d.jpg";